import { ReportGeneratorService } from './report-generator.service';
import { Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoggerService } from 'src/shared/logger/logger.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogReportGeneratorComponent } from 'src/shared/Dialogs/dialog-report-generator/dialog.report-generator.component';

export interface sysHeader {
  name: string;
  shownValue: string;
  completed: boolean;
  color: ThemePalette;
  subtasks?: sysHeader[];
}

@Component({
  selector: 'app-report-generator',
  templateUrl: './report-generator.component.html',
  styleUrls: ['./report-generator.component.css'],
  providers: [ReportGeneratorService]
})

export class ReportGeneratorComponent implements OnInit {
  targetFolder: { id: Number, text: string } = { id: null, text: "" };
  received_selected_items = [];
  allComplete: boolean = false;
  systemHeader: sysHeader = {
    shownValue: null,
    name: 'Select All',
    completed: false,
    color: 'accent',
    subtasks: [
      { shownValue: "DNS Domain", name: 'dns_domain_name', completed: false, color: 'primary' },
      { shownValue: "DNS Server 1", name: 'dns_server1', completed: false, color: 'primary' },
      { shownValue: "DNS Server 2", name: 'dns_server2', completed: false, color: 'primary' },
      { shownValue: "DNS Server 3", name: 'dns_server3', completed: false, color: 'primary' },
      { shownValue: "H323 Address", name: 'h323_gatekeeper_address', completed: false, color: 'primary' },
      { shownValue: "H323 Gatekeeper Status", name: 'h323_gatekeeper_status', completed: false, color: 'primary' },
      { shownValue: "H323 Gatekeeper Reason", name: 'h323_gatekeeper_reason', completed: false, color: 'primary' },
      { shownValue: "H323 Gatekeeper Mode", name: 'h323_gatekeeper_mode', completed: false, color: 'primary' },
      { shownValue: "H323 E164", name: 'h323_e164', completed: false, color: 'primary' },
      { shownValue: "H323 ID", name: 'h323_id', completed: false, color: 'primary' },
      { shownValue: "H323 Port", name: 'h323_gatekeeper_port', completed: false, color: 'primary' },
      { shownValue: "IP Address", name: 'system_ip', completed: false, color: 'primary' },
      { shownValue: "Last Monitor Date", name: 'last_monitored_date', completed: false, color: 'primary' },
      { shownValue: "MAC Address", name: 'system_mac_address', completed: false, color: 'primary' },
      { shownValue: "NTP Server", name: 'ntp_server1', completed: false, color: 'primary' },
      { shownValue: "Product ID", name: 'product_id', completed: false, color: 'primary' },
      { shownValue: "QOS Audio", name: 'qos_audio', completed: false, color: 'primary' },
      { shownValue: "QOS Data", name: 'qos_data', completed: false, color: 'primary' },
      { shownValue: "QOS Signaling", name: 'qos_signaling', completed: false, color: 'primary' },
      { shownValue: "QOS Video", name: 'qos_video', completed: false, color: 'primary' },
      { shownValue: "Remedy Ticket No.", name: 'remedy_opened_ticket', completed: false, color: 'primary' },
      { shownValue: "Serial Number", name: 'serial_number', completed: false, color: 'primary' },
      { shownValue: "SIP Auth Username", name: 'sip_authentication_username', completed: false, color: 'primary' },
      { shownValue: "SIP Listen Port", name: 'sip_listen_port', completed: false, color: 'primary' },
      { shownValue: "SIP Name", name: 'sip_display_name', completed: false, color: 'primary' },
      { shownValue: "SIP Proxy Address 1", name: 'sip_proxy_address', completed: false, color: 'primary' },
      { shownValue: "SIP Proxy Address 2", name: 'sip_proxy_address2', completed: false, color: 'primary' },
      { shownValue: "SIP Proxy Address 1 Status", name: 'sip_proxy_address_status', completed: false, color: 'primary' },
      { shownValue: "SIP Proxy Address 2 Status", name: 'sip_proxy_address2_status', completed: false, color: 'primary' },
      { shownValue: "SIP Registration Status", name: 'sip_registration_status', completed: false, color: 'primary' },
      { shownValue: "SIP Registration URI", name: 'sip_registration_uri', completed: false, color: 'primary' },
      { shownValue: "SIP TLS Verify", name: 'sip_tls_verify', completed: false, color: 'primary' },
      { shownValue: "Software Name", name: 'software_name', completed: false, color: 'primary' },
      { shownValue: "Software Version", name: 'software_version', completed: false, color: 'primary' },
      { shownValue: "System Name", name: 'system_name', completed: false, color: 'primary' },
      { shownValue: "System Notes", name: 'ops_note', completed: false, color: 'primary' },
      { shownValue: "System Status", name: 'status', completed: false, color: 'primary' },
      { shownValue: "Time Zone", name: 'system_time_zone', completed: false, color: 'primary' }
    ]
  };

  systemsData: any[] = [];
  disableFetchButton: boolean = false;

  constructor(
    private loggerService: LoggerService,
    private _snackBar: MatSnackBar,
    private reportGeneratorService: ReportGeneratorService,
    public dialog: MatDialog
  ) {

  }

  ngOnInit(): void {
  }

  recieve_selected_folder(folderDetails) {
    let disableBtn: boolean = false;
    this.targetFolder.id = null;
    this.targetFolder.text = null;
    if (folderDetails && disableBtn == false) {
      if (folderDetails.children && folderDetails.children.length > 0
        && folderDetails.children[0].value.type == 'folder') {
        disableBtn = true;
        return;
      }
    }
    this.targetFolder.id = folderDetails.value.id;
    this.targetFolder.text = folderDetails.text;
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });
  }

  recieve_selected_multiple_items(items: any) {
    this.received_selected_items = items;
  }

  updateAllComplete() {
    this.allComplete = this.systemHeader.subtasks != null && this.systemHeader.subtasks.every(t => t.completed);
  }

  someComplete(): boolean {
    if (this.systemHeader.subtasks == null) {
      return false;
    }
    return this.systemHeader.subtasks.filter(t => t.completed).length > 0 && !this.allComplete;
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
    if (this.systemHeader.subtasks == null) {
      return;
    }
    this.systemHeader.subtasks.forEach(t => (t.completed = completed));
  }


  sendDataToReportGenerator() {
    this.disableFetchButton = true;
    this.reportGeneratorService.systemsReceiver(this.adjustHeadersToBeSent(), this.adjustUnitsIDsToBeSent()).subscribe(data => {
      //length for Vodafone_ is 9 letters

      let Vodafone_Length: number = 10;
      for (let item of data) {
        let fullPath: string = item.entire_path;
        let firstPartOfStringAfterVodafone_: string = fullPath.slice(
          fullPath.indexOf("Vodafone&&") + Vodafone_Length, fullPath.length
        );
        let nextDashIndex: number = firstPartOfStringAfterVodafone_.indexOf("&&");

        item.main_folder = firstPartOfStringAfterVodafone_.includes("&&") ? firstPartOfStringAfterVodafone_.slice(0, nextDashIndex) : firstPartOfStringAfterVodafone_

        item.secondary_folders = (firstPartOfStringAfterVodafone_.length == item.main_folder.length) ? "" : firstPartOfStringAfterVodafone_.slice(
          nextDashIndex + 2, firstPartOfStringAfterVodafone_.length
        );

        if (item.secondary_folders.includes("&&")) {
          item.secondary_folders = item.secondary_folders.replaceAll("&&", "-")
        };

      }

      this.systemsData = data;
      // this.openSnackBar("Date Retrieved.", "Done");
      this.disableFetchButton = false;
      this.openDialog()
    }, err => {
      this.disableFetchButton = false;

      this.openSnackBar(err?.error?.message ? err?.error?.message : "Error while processing your request", "Error");
    })
  }

  adjustHeadersToBeSent() {
    let headerString: string = "";

    this.systemHeader.subtasks.forEach(i => {
      if (i.completed) {
        headerString += (i.name + ",");
      }
    });

    headerString = headerString.slice(0, -1);

    return headerString;
  }

  adjustUnitsIDsToBeSent() {
    let ids: string = "(";

    this.received_selected_items.forEach(i => {
      ids += (i.value + ",");
    });

    ids = ids.slice(0, -1);
    ids += (")");
    return ids;
  }

  adjustHeadersForDialog() {
    let data: string[] = [];
    this.systemHeader.subtasks.forEach(i => {
      if (i.completed) {
        data.push(i.name);
      }
    });
    data = ["main_folder", "secondary_folders", ...data, "remedy_location_name", "remedy_market_name"]

    return { stringArr: data, unitsArr: this.systemsData };
  }




  openDialog(): void {
    let dataToBeSent: { stringArr: string[], unitsArr: any[] } = this.adjustHeadersForDialog();

    const dialogRef = this.dialog.open(DialogReportGeneratorComponent, {
      minWidth: '95vw',
      maxWidth: '95vw',
      disableClose: true,
      data: dataToBeSent
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //this.deleteSystem(systemToBeDeleted);
      }
    });
  }
}
